export default "__VITE_ASSET__iNUN4Ww7__"